import type { TeacherLessonListVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveTeacherLessons = createApiThunk<TeacherLessonListVM[], string>(
  "lessons/adminRetrieveTeacherLessons",
  async (teacherId: string, { extra: { adminRepository } }) => {
    return adminRepository!.teacherLessons(teacherId);
  },
);
